import React from "react";
import { projects, projectsContent } from "../../data/content";
import { ArrowUpRight, GithubLogo, Globe, Briefcase } from "@phosphor-icons/react";

export const WorkSection: React.FC = () => {
  return (
    <section id="work" className="py-20 sm:py-24 border-b border-[#242320] scroll-mt-20 sm:scroll-mt-24">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        {/* Section Header */}
        <div className="mb-10 sm:mb-12 text-left">
          <div className="flex items-center gap-2 mb-2">
            <Briefcase className="w-4 h-4 text-[#E5983A]" weight="bold" />
            <span className="text-xs font-mono uppercase tracking-widest text-[#E5983A]">
              {projectsContent.sectionTag}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold font-display tracking-tight text-[#F3F2EE] mb-2.5">
            {projectsContent.title}
          </h2>
          <p className="text-sm font-mono text-[#8C8A84] max-w-xl">
            {projectsContent.subtitle}
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-7">
          {projects.map((project, idx) => {
            const isGitHub = project.url.includes("github.com");
            return (
              <a
                key={idx}
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex flex-col justify-between p-6 sm:p-7 rounded-2xl bg-[#181716] border border-[#2A2926] hover:border-[#E5983A]/40 transition-all duration-300 hover:shadow-xl hover:shadow-black/40 cursor-pointer"
              >
                <div>
                  {/* Top Bar with Project Link Icon */}
                  <div className="flex items-center justify-between gap-2 mb-4">
                    <span className="text-xs font-mono text-[#8C8A84] flex items-center gap-1.5">
                      {isGitHub ? (
                        <>
                          <GithubLogo size={14} className="text-[#C8C6BE]" />
                          <span>SOURCE CODE</span>
                        </>
                      ) : (
                        <>
                          <Globe size={14} className="text-[#E5983A]" />
                          <span>DEPLOYED APP</span>
                        </>
                      )}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-[#201F1D] border border-[#2D2B27] flex items-center justify-center text-[#8C8A84] group-hover:text-[#E5983A] group-hover:border-[#E5983A]/40 transition-all duration-200">
                      <ArrowUpRight size={16} weight="bold" />
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold font-display text-[#F3F2EE] group-hover:text-[#E5983A] transition-colors duration-200 mb-2.5">
                    {project.name}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-[#A6A39A] leading-relaxed mb-5">
                    {project.description}
                  </p>
                </div>

                {/* Tags Footer */}
                {project.tags.length > 0 && (
                  <div className="pt-4 border-t border-[#242320] flex flex-wrap gap-1.5">
                    {project.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-[11px] font-mono px-2 py-0.5 rounded bg-[#201F1D] text-[#C8C6BE] border border-[#2D2B27]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
